/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Discord_TokenInputs */



/**
* | output |
* | --- |
* | "Failed to authenticate with Discord." |
*
* @param {Login_Error_Discord_TokenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_discord_token = /** @type {((inputs?: Login_Error_Discord_TokenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Discord_TokenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'authentification avec Discord.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al autenticar con Discord.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao autenticar com Discord.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Autenticazione con Discord fallita.")
	return /** @type {LocalizedString} */ ("Failed to authenticate with Discord.")
});